import React from 'react';
import {
    DESTINATION_WEDDING_MODEL,
    MAKE_UP_ARTIST_MODEL,
    VENUE_CORPORATE_STANALONE,
    VENUE_CORPORATE_STANALONE_GURGAON,
    VENUE_MODEL,
} from '../../../../../constants/constants';
import getQuotestyles from '../../../../../styles/getquote.module.css';
import Icon from '../../../../../layouts/common/icons/Icon';

const TITLE = 'Thank You For Your Enquiry!';

function ThankyouSegment({ mode }) {
    const getMessage = () => {
        switch (mode) {
            case MAKE_UP_ARTIST_MODEL:
                return 'We will pass your enquiry to relevant makeup artists.';
            case VENUE_MODEL:
                return 'Thank you for your enquiry! Our team will connect with shortly.';
            case VENUE_CORPORATE_STANALONE:
                return 'Thank you for your enquiry! Our team will connect with shortly.';
            case VENUE_CORPORATE_STANALONE_GURGAON:
                return 'Thank you for your enquiry! Our team will connect with shortly.';
            case DESTINATION_WEDDING_MODEL:
                return 'Our team will connect with you shortly.';
            default:
                return '';
        }
    };
    const getImage = () => {
        switch (mode) {
            case MAKE_UP_ARTIST_MODEL:
                return 'vm_thank_you_gif';
            case VENUE_MODEL:
                return 'vm_get_quote_venue_thankyou_image';
            case VENUE_CORPORATE_STANALONE:
                return 'vm_get_quote_venue_thankyou_image';
            case VENUE_CORPORATE_STANALONE_GURGAON:
                return 'vm_get_quote_venue_thankyou_image';
            case DESTINATION_WEDDING_MODEL:
                return 'vm_get_quote_venue_thankyou_image';
            default:
                return '';
        }
    };

    const message = getMessage();
    const imageKey = getImage();

    return (
        <div className={getQuotestyles.thankYouSlide}>
            <h2 className={getQuotestyles.thankYouHeading}>{TITLE}</h2>
            {imageKey ? (
                <Icon iconName={imageKey} className={getQuotestyles.thankYouIllustration} />
            ) : null}
            {message ? <p className={getQuotestyles.thankYouMessage}>{message}</p> : null}
        </div>
    );
}

export default ThankyouSegment;
